import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatDate = (date) => {
  const dateStr = date;
  let formatDate = '';
  // Handle both hyphen and slash formats
  const parts = dateStr.includes('-') ? dateStr.split('-') : dateStr.split('/');

  // Check if it's already in YYYY-MM-DD format
  if (parts[0].length === 4) {
    formatDate = dateStr;
  } else {
    // Convert from DD-MM-YYYY to YYYY-MM-DD
    const [day, month, year] = parts;
    formatDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }

  return formatDate;
};

export const formatDateString = (date) => {
  if (!(date instanceof Date) || isNaN(date)) return '';
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
};

export const parseCSV = (file, callback) => {
  Papa.parse(file, {
    header: true,
    skipEmptyLines: true,
    complete: (results) => callback(results.data),
  });
};

export const parseExcel = (file, callback) => {
  const reader = new FileReader();
  reader.onload = (e) => {
    const data = new Uint8Array(e.target.result);
    const workbook = XLSX.read(data, { type: 'array' });
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

    // Remove keys that start with __EMPTY
    const cleaned = jsonData.map((row) => {
      const newRow = {};
      for (const key in row) {
        if (!key.startsWith('__EMPTY')) {
          newRow[key] = row[key];
        }
      }
      return newRow;
    });

    callback(cleaned);
  };
  reader.readAsArrayBuffer(file);
};

export const validateRequiredFields = (jsonData, requiredFields) => {
  const firstRow = jsonData[0] || {};
  return requiredFields.filter((field) => !(field in firstRow));
};

export async function parseBlobToJson(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        resolve(JSON.parse(reader.result));
      } catch (e) {
        reject(e);
      }
    };
    reader.onerror = () => reject(new Error('Failed to read blob'));
    reader.readAsText(blob);
  });
}

export const getLogoUrl = (theme) => {
  try {
    const logoData = JSON.parse(localStorage.getItem('logo'));
    if (!logoData) return '';

    // Determine the actual theme (handle 'system' theme)
    const actualTheme =
      theme === 'system'
        ? window.matchMedia('(prefers-color-scheme: dark)').matches
          ? 'dark'
          : 'light'
        : theme;

    // If theme is dark and darkModeLogo exists, use it
    if (actualTheme === 'dark' && logoData.darkModeLogo) {
      return logoData.darkModeLogo;
    }

    // Otherwise use the regular logo
    return logoData.logo || '';
  } catch (error) {
    console.error('Error getting logo URL:', error);
    return '';
  }
};

// Function to format key: replace underscores with spaces and capitalize first letter
export const formatKey = (key) => {
  return key
    .replace(/_/g, ' ') // Replace underscores with spaces
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
};
